import createApiServices from "./createApiServices";
import { extendUrlFulfillment } from "../../views/helpers/extenent-url";
import queryString from 'query-string'

const prefixURL = `${extendUrlFulfillment.url}/api` || 'https://fulfillment-staging.merchize.com/api'

const api = createApiServices({ baseUrl: prefixURL})

export const getListIssues = (data) => {
    return api.makeAuthRequest({
        url: `/supplier/issues/search`,
        method: 'POST',
        data,
    })
}

export const getListIssueTypes = () => {
    return api.makeAuthRequest({
        url: `/supplier/issue-types`,
        method: 'GET',
    })
}

export const confirmIssue = (id, data) => {
    return api.makeAuthRequest({
        url: `/supplier/confirm-issue/${id}`,
        method: 'POST',
        data,
    })
}

export const getExportIssue = (data) => {
    return api.makeAuthRequest({
        url: `/supplier/issues/export/csv/fac?${data}`,
        method: 'GET',
    })
}

export const getSupplier1C = () => {
    return api.makeAuthRequest({
        url: `/supplier/v2/suppliers`,
        method: 'GET',
    })
}

export const getIssueTypeReport = (params, supplierId) => {
    const query = queryString.stringify(params)

    return api.makeAuthRequest({
        url: `/supplier/fulfillment-issue-report/by-type/${supplierId}?${query}`,
        method: 'GET'
    })
}

export const getIssueProductTypeReport = (params, supplierId) => {
    const query = queryString.stringify(params)

    return api.makeAuthRequest({
        url: `/supplier/fulfillment-issue-report/by-product/${supplierId}?${query}`,
        method: 'GET'
    })
}

export const getIssueStorePackageReport = (data, supplierId) => {
    return api.makeAuthRequest({
        url: `/supplier/fulfillment-issue-report/by-store-and-package/${supplierId}`,
        method: 'POST',
        data
    })
}

export const getIssueStorePackageItemReport = (data, supplierId) => {
    return api.makeAuthRequest({
        url: `/supplier/fulfillment-issue-report/by-store-and-package-item/${supplierId}`,
        method: 'POST',
        data
    })
}

export const getListShippingCarrierApp = async (payload) => {
    const res = await api.makeAuthRequest({
        url: `/shipping/shipping-carrier-app/search`,
        method: 'POST',
        data: { ...payload, suppliers: ['MCVN'] },
    })
    if (!res || !res.success) return res

    const seen = new Set()
    const shippingCarriers = (res.data.applications || [])
        .map(app => app.shipping_carrier)
        .filter(carrier => {
            if (!carrier || seen.has(carrier._id)) return false
            seen.add(carrier._id)
            return true
        })

    return { ...res, data: { ...res.data, shippingCarriers } }
}

